import { render, staticRenderFns } from "./EditVillagePage.vue?vue&type=template&id=53a463ee&"
import script from "./EditVillagePage.vue?vue&type=script&lang=js&"
export * from "./EditVillagePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports